document.addEventListener('click', function (e) {
  var toggle = e.target.closest('[data-menu-toggle]');
  if (toggle) {
    var nav = document.querySelector('[data-mobile-nav]');
    if (nav) nav.classList.toggle('open');
  }

  var thumb = e.target.closest('[data-thumb]');
  if (thumb) {
    var main = document.querySelector('[data-gallery-main]');
    if (main) main.src = thumb.dataset.full;
    document.querySelectorAll('[data-thumb]').forEach(function (b) {
      b.setAttribute('aria-current', b === thumb ? 'true' : 'false');
    });
  }

  var step = e.target.closest('[data-qty-step]');
  if (step) {
    var input = step.parentElement.querySelector('input');
    var next = parseInt(input.value || '1', 10) + parseInt(step.dataset.qtyStep, 10);
    input.value = next < 1 ? 1 : next;
  }
});

(function(){var els=document.querySelectorAll('.reveal');if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('in')});return}
var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -10% 0px'});els.forEach(function(e){io.observe(e)})})();
